import { Badge } from '@chakra-ui/react';
import { TLessonLearner } from '../api/server';
import {
  APPROVAL_FLG,
  CANCEL_FLG,
  STOP_FLG,
  DELETE_FLG,
  CANCEL_STATUS,
  PARTICIPATION_STATUS,
} from '../configs';
import {  TLessonLog } from '../interfaces/learnerInterface';

export function getLessonStatusBadge(lesson: any) {
  let status = '';
  let colorScheme = '';
  if(lesson?.delete_flg == DELETE_FLG.DELETED) {
    if (lesson?.cancel_flg == CANCEL_FLG.CANCELED_COMPANY) {
      status = 'キャンセル（企業）';
      colorScheme = 'red';
    }
    else if (lesson?.cancel_flg == CANCEL_FLG.CANCELED_TEACHER) {
      status = 'キャンセル（講師）';
      colorScheme = 'red';
    }
    else if (lesson?.cancel_flg == CANCEL_FLG.CANCELED_MANAGER) {
      status = 'キャンセル（運用）';
      colorScheme = 'red';
    }
    else if (lesson?.cancel_flg == CANCEL_FLG.CANCELED_LEARNER) {
      status = 'キャンセル（学習者）';
      colorScheme = 'red';
    }
  } else {
    if (lesson?.approval_flg == APPROVAL_FLG.APPROVED) {
      status = '予約';
      colorScheme = 'green';
    }
    if (new Date(lesson?.end_datetime) < new Date()) {
      status = '終了';
      colorScheme = 'gray';
    }
    if (lesson?.approval_flg != APPROVAL_FLG.APPROVED) {
      status = '教師承認待ち';
      colorScheme = 'yellow';
    }
  }

  return (
    <>
      <Badge colorScheme={colorScheme} p={'5px'} textAlign="center">
        {status}
      </Badge>
    </>
  );
}

/**
 * 学習者のレッスンステータス
 * @param t_lesson_learner
 * @returns
 */
export function getLessonLearnerStatusBadge(t_lesson_learner: TLessonLearner) {
  let status = '';
  let colorScheme = '';

  if (t_lesson_learner.participation_status === PARTICIPATION_STATUS.PARTICIPATED) {
    status = '参加';
    colorScheme = 'green';
  } else if (t_lesson_learner.participation_status === PARTICIPATION_STATUS.NOT_PARTICIPATED) {
    status = '不参加';
    colorScheme = 'gray';
  } else if (t_lesson_learner.participation_status === PARTICIPATION_STATUS.WILL_PARTICIPATE) {
    status = '参加予定';
    colorScheme = 'cyan';
  } else if (t_lesson_learner.participation_status === PARTICIPATION_STATUS.CANCELLED) {
    status = 'キャンセル';
    colorScheme = 'red';
    if (t_lesson_learner.cancel_status === CANCEL_STATUS.CANCELLED_LEARNER_RESCHEDULE) {
      status = 'キャンセル\n（学習者・リスケ対象）';
    } else if (t_lesson_learner.cancel_status === CANCEL_STATUS.CANCELLED_LEARNER_NOT_RESCHEDULE) {
      status = 'キャンセル\n（学習者・リスケ対象外）';
    } else if (t_lesson_learner.cancel_status === CANCEL_STATUS.CANCELLED_COMPANY_NOT_RESCHEDULE) {
      status = 'キャンセル\n（企業・リスケ対象外）';
    } else if (t_lesson_learner.cancel_status === CANCEL_STATUS.CANCELLED_COMPANY_RESCHEDULE) {
      status = 'キャンセル\n（企業・リスケ対象）';
    } else if (t_lesson_learner.cancel_status === CANCEL_STATUS.CANCELLED_ADMIN_NOT_RESCHEDULE) {
      status = 'キャンセル\n（運営・リスケ対象外）';
    } else if (t_lesson_learner.cancel_status === CANCEL_STATUS.CANCELLED_ADMIN_RESCHEDULE) {
      status = 'キャンセル\n（運営・リスケ対象）';
    }
  }

  return (
    <>
      <Badge
        colorScheme={colorScheme}
        width="8rem"
        p={'5px'}
        textAlign="center"
        whiteSpace={'pre-wrap'}
      >
        {status}
      </Badge>
    </>
  );
}

const judgeAttendance = (t_lesson_logs: TLessonLog[] | undefined) => {
  // ログがない場合は不参加とみなす
  if (!t_lesson_logs || t_lesson_logs.length === 0) {
    return false;
  }
  return t_lesson_logs.some((log: any) => log.lesson_log_type === 'ENTERING_LEARNER');
};
